import { createStore } from '@'

export const $users = createStore('users:users')
export const $roles = createStore('users:roles')
